export interface SubmitSalesLeads {
	name: string;
	phone: string;
	email: string;
	language: string;
	crNumber: string;
	productId: string;
	organisationName: string;
	productName: string;
}

export interface ServiceInfo {
	crNumber: string;
	subscriberNo: string;
	productId: string;
	billingType: string;
	accountType: string;
}

export interface BandwidthOnDemand {
	subscriberNo: string;
	billingType: string;
	accountType: string;
	planCategory: string;
	otp?: string;
}
export interface CopperPlanDetails {
	commitmentDetails: {
		productId?: string;
		productName?: string;
	};
	removeProductIds?: string[];
	gisDetails: string;
}
interface SalesLeads {
	productId?: string;
	name?: string;
	emailAddress: string;
	templateKey: string;
}
export interface ChangeFbbOrder {
	subscriberNo: string;
	userFullName: string;
	currentProductId: string;
	billingAccountNumber: string;
	newProductId: string;
	emailAddress: string;
	mobileNumber: string;
	copperPlan?: boolean;
	copperPlanDetails?: CopperPlanDetails;
	salesLeads?: SalesLeads[];
	templateKey?: string;
	otp: string;
}
export interface LineDetails {
	categoryId?: string;
	productId?: string;
	userName?: string;
	bandwidth?: string;
	requestedPlan: string;
	selectedServices: string;
	additionalService: Services;
	staticService: Services;
	templateKey?: string;
	salesLeads?: SalesLeads[];
}
interface DocumentType {
	name?: string;
	content?: string;
}

export interface CreateFbbOrder {
	upId: number;
	sendSmsToUser: boolean;
	firstName: string;
	contactNumber1: string;
	contactNumber2?: string;
	emailId: string;
	gisDetails: string;
	preferredTimeToContact: string;
	documents: DocumentType[];
	templateKey: string;
	lineDetails: LineDetails[];
	idExpiryDate?: string;
	requestChannel?: string;
	staffRemarks?: string;
	customerName?: string;
	customerId?: string;
}

export interface Services {
	categoryId: string;
	productIds: string[];
}
export interface OrderSummaryLineDetails {
	adslUserName: string;
	productId: string;
	categoryId: string;
	additionalService: Services;
	staticService: Services;
}
export interface FbbOrderSummary {
	lineDetails: OrderSummaryLineDetails[];
}
export function createFbbOrder(data: CreateFbbOrder) {
	return { ...data };
}

export function changeFbbOrder(data: ChangeFbbOrder) {
	return { ...data };
}

export function getFbbOrderSummary(data: FbbOrderSummary) {
	return { ...data };
}
